// @flow
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import {
  mx, my, px, pr, pb, mt, p
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import { MobileFiltersPreview } from '@components/MobileFilters';
import theme from '@theme';

const { colors } = theme;

export const StyledWrapper = styled.div`
  max-width: 1500px;
  position: relative;
  width: 100%;

  ${breakpoint('tablet')`
    ${px(0)}
  `}
  box-sizing: border-box;
  -moz-box-sizing: border-box;
`;

export const StyledHeadlineText = styled(Grid)`
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid gray;
  ${my(3)}
  display: flex;
  width: 100%;

  & > h1 {
    font-size: 28px;
    font-weight: 600;
    line-height: 1.29;
    color: ${colors.darkBlue};
    ${pr(1)}
    ${pb(1)}
  }

  & > p {
    font-size: 18px;
    color: ${colors.darkBlue};
    ${pb(1)}
  }

  ${breakpoint('desktop')`
    ${my(4)}
  `}
`;

export const StyledList = styled(Grid)`
  ${mt(4)}
  min-height: 50vh;
  ${pb(4)}
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(auto-fill, minmax(300px, 0.8fr));
  align-items: center;

  ${breakpoint('mobile', 'tablet')`
   grid-template-columns: repeat(auto-fill, minmax(162px, 1fr));
   min-height: 35vh;
  `}

 ${breakpoint('mobile')`
   ${px(3)}
  `}

  ${breakpoint('tablet', 'desktop')`
   ${px(4)}
  `}

  ${breakpoint('desktop')`
   ${px(5)}
  `}
`;

export const StyledSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50vh;
`;

export const StyledMobileFiltersPreview = styled(MobileFiltersPreview)`
  ${mx(-3)}
  ${p(4)}
`;
